import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import ErrorPage from '@shared/containers/ErrorPage/ErrorPage.tsx';
import { CountryThemeProvider } from '@shared/providers/CountryThemeProvider/CountryThemeProvider.tsx';
import { RolesDetailsProvider } from '@shared/providers/RolesDetailsProvider/RolesDetailsProvider';
import { UserDetailsProvider } from '@shared/providers/UserDetailsProvider/UserDetailsProvider.tsx';
import { logError } from '@shared/utils/logError';

function AuthWrapper() {
  const handleErrorBoundaryError = (error: Error) => logError(error);

  return (
    <RolesDetailsProvider>
      <UserDetailsProvider>
        <ErrorBoundary fallback={<ErrorPage />} onError={handleErrorBoundaryError}>
          <CountryThemeProvider>
            <Outlet />
          </CountryThemeProvider>
        </ErrorBoundary>
      </UserDetailsProvider>
    </RolesDetailsProvider>
  );
}

export default AuthWrapper;
